<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import acpmDocumentAPI from "../../../services/standards/acpm/acpmDocumentAPI";
import acpmProcedureAPI from "../../../services/standards/acpm/acpmProcedureAPI";
import acpmMatrixAPI from "../../../services/standards/acpm/acpmMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import { dateFormat } from "@/utils/helpers/format";

/**
 * 7.1.2 Toma de Medidas Correctivas, Preventivas y de Mejora — hub del ítem:
 * (1) formatos ACPM en blanco descargables del bucket,
 * (2) subida libre del archivo diligenciado con metadatos (sin firma),
 * (3) Procedimiento ACPM online versionable → PDF firmado (SST-FT-025),
 * (4) Matriz ACPM online versionable + dashboard → PDF firmado (SST-FT-026).
 * Los formularios versionables llevan su editor en vistas aparte.
 */
export default {
  page: {
    title: "7.1.2 Medidas Correctivas, Preventivas y de Mejora",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      title: "7.1.2 Medidas Correctivas, Preventivas y de Mejora",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medidas Correctivas, Preventivas y de Mejora",
          active: true,
        },
      ],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      // Subida libre de documentos ACPM diligenciados
      acpmDocs: [],
      acpmDoc: {
        name: null,
        doc_type: "Matriz ACPM",
        upload_date: today,
        responsible: null,
        observations: null,
      },
      acpmFile: null,
      acpmSubmitting: false,
      docTypes: ["Procedimiento ACPM", "Matriz ACPM", "Evidencia", "Otro"],
      // Módulos versionables online
      procedures: [],
      matrices: [],
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(58) // 58 = 7.1.2
        .then((response) => {
          this.itemData = response;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 58) // 58 = 7.1.2
        .then((response) => {
          this.item = response || null;
          this.itemStatus =
            response && response.status !== undefined
              ? response.status
              : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async changeItemStatus(itemStatus) {
      try {
        await newScoresAPI.calculateScores({
          companies_id: this.companyID,
          item_id: 58, // 58 = 7.1.2
          status: itemStatus,
        });

        Swal.fire({
          title: "¡Éxito!",
          text: "¡Se ha cambiado el estado del ítem con éxito!",
          icon: "success",
          type: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });

        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        Swal.fire({
          title: "¡Error!",
          text: "¡No se ha actualizado el estado del ítem!",
          type: "error",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        setTimeout(() => window.location.reload(), 2000);
        console.error(error);
      }
    },

    getRole(name, roles) {
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false;
        } else {
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        }
        const permissions = this.$store.state.auth.info.permissions;
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        return enabled && role ? true : false;
      } else {
        return false;
      }
    },

    statusBadgeClass(s) { return s === "signed" ? "badge-success" : "badge-secondary"; },
    statusText(s) { return s === "signed" ? "Firmado" : "Borrador"; },

    // ── Procedimiento ACPM (versionable) ──
    getProcedures() {
      acpmProcedureAPI.getAll(this.companyID, 1)
        .then((r) => { this.procedures = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newProcedure() { this.$router.push({ path: `/forms/estandares/${this.companyID}/acpm-procedimiento` }); },
    editProcedure(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/acpm-procedimiento/${id}` }); },
    downloadProcedurePdf(id) { window.open(acpmProcedureAPI.pdfUrl(id), "_blank"); },
    cloneProcedure(id) {
      Swal.fire({
        title: "¿Crear nueva versión?", text: "Se clonará esta versión del procedimiento en una nueva editable.",
        icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        acpmProcedureAPI.cloneVersion(id).then((r) => { if (r && r.id) this.editProcedure(r.id); })
          .catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteProcedure(id) {
      Swal.fire({
        title: "¿Eliminar versión?", icon: "warning", showCancelButton: true,
        confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        acpmProcedureAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminada", icon: "success", timer: 1200, showConfirmButton: false });
          this.getProcedures();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },

    // ── Matriz ACPM (versionable) ──
    getMatrices() {
      acpmMatrixAPI.getAll(this.companyID, 1)
        .then((r) => { this.matrices = (r && r.List && r.List.data) ? r.List.data : []; })
        .catch((e) => console.log(e));
    },
    newMatrix() { this.$router.push({ path: `/forms/estandares/${this.companyID}/acpm-matriz` }); },
    editMatrix(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/acpm-matriz/${id}` }); },
    downloadMatrixPdf(id) { window.open(acpmMatrixAPI.pdfUrl(id), "_blank"); },
    cloneMatrix(id) {
      Swal.fire({
        title: "¿Crear nueva versión?", text: "Se clonarán las acciones de esta versión en una nueva editable.",
        icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        acpmMatrixAPI.cloneVersion(id).then((r) => { if (r && r.id) this.editMatrix(r.id); })
          .catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteMatrix(id) {
      Swal.fire({
        title: "¿Eliminar versión?", text: "Se eliminará la matriz y sus acciones.",
        icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        acpmMatrixAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminada", icon: "success", timer: 1200, showConfirmButton: false });
          this.getMatrices();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },

    // Descarga de los formatos en blanco del ítem 7.1.2 (ACPM) alojados en el bucket.
    descargarFormato(tipo) {
      const base =
        "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/7.1.2";
      const file =
        tipo === "procedimiento"
          ? "PROCEDIMIENTO_MEDIDAS_ACPM_7.1.2.docx"
          : "MATRIZ_ACPM_7.1.2.xlsx";
      window.open(`${base}/${file}`);
    },

    dateConvert(date) {
      return date ? dateFormat(date) : "";
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    // ── Documentos ACPM diligenciados (subida libre) ──
    onAcpmFile(e) {
      this.acpmFile = (e.target.files && e.target.files[0]) || null;
    },

    getAcpmDocs() {
      acpmDocumentAPI
        .getAll(this.companyID)
        .then((r) => {
          this.acpmDocs = r && r.data && r.data.data ? r.data.data : [];
        })
        .catch((err) => console.log(err));
    },

    async saveAcpmDoc() {
      if (!this.acpmDoc.name || !this.acpmFile) {
        Swal.fire({
          title: "Atención",
          text: "Indica un nombre y selecciona un archivo.",
          icon: "warning",
        });
        return;
      }
      this.acpmSubmitting = true;
      try {
        const base =
          process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const nit = this.nit || this.$store.getters["company/getCompany"].nit;
        const path = `${base}/${nit}/7.1.2/diligenciados/${Date.now()}_${this.acpmFile.name}`;
        const ok = await uploadDocument(path, this.acpmFile);
        if (!ok) throw new Error("upload");

        await acpmDocumentAPI.save({
          companies_id: this.companyID,
          name: this.acpmDoc.name,
          doc_type: this.acpmDoc.doc_type,
          upload_date: this.acpmDoc.upload_date,
          responsible: this.acpmDoc.responsible,
          observations: this.acpmDoc.observations,
          file: `${process.env.VUE_APP_BUCKET}/${path}`,
        });

        newScoresAPI
          .calculateScores({
            companies_id: this.companyID,
            item_id: 58,
            status: "Pendiente",
          })
          .catch(() => {});

        const today = new Date().toISOString().slice(0, 10);
        this.acpmDoc = {
          name: null,
          doc_type: "Matriz ACPM",
          upload_date: today,
          responsible: null,
          observations: null,
        };
        this.acpmFile = null;
        if (this.$refs.acpmFile) this.$refs.acpmFile.reset();
        this.getAcpmDocs();

        Swal.fire({
          title: "¡Éxito!",
          text: "Documento cargado.",
          icon: "success",
          timer: 1400,
          showConfirmButton: false,
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar el documento.", "error");
      } finally {
        this.acpmSubmitting = false;
      }
    },

    deleteAcpmDoc(id) {
      Swal.fire({
        title: "¿Eliminar documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        acpmDocumentAPI
          .delete(id)
          .then(() => {
            Swal.fire({
              title: "Eliminado",
              icon: "success",
              timer: 1200,
              showConfirmButton: false,
            });
            this.getAcpmDocs();
          })
          .catch((e) => {
            console.log(e);
            Swal.fire("Error", "No se pudo eliminar", "error");
          });
      });
    },
  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getAcpmDocs();
    this.getProcedures();
    this.getMatrices();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <!-- Descripción + estado + descargas -->
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Cuando la revisión por la Alta Dirección evidencie que las medidas de prevención y
                      control frente a los peligros y riesgos son inadecuadas o pueden dejar de ser eficaces,
                      la empresa debe definir, implementar y conservar evidencia documental de las Acciones
                      Correctivas, Preventivas y de Mejora (ACPM) adoptadas.
                    </p>
                    <p class="text-justify">
                      Estas acciones también se derivan de auditorías, investigaciones de accidentes e
                      incidentes de trabajo, enfermedades laborales, inspecciones de seguridad, seguimiento a
                      indicadores, recomendaciones del COPASST y requerimientos de la ARL o de las autoridades
                      competentes, garantizando la aplicación del ciclo PHVA y la mejora continua del SG-SST.
                    </p>
                    <p class="text-justify">
                      Descargue el <b>procedimiento ACPM</b> y la <b>matriz ACPM</b> en blanco, diligéncielos y
                      súbalos en la sección inferior como evidencia del seguimiento y control de las desviaciones
                      halladas en el SG-SST.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-12 text-right m-b-0 d-flex justify-content-end flex-wrap align-items-center">
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('procedimiento')">
                  <i class="bx bx-download"></i> Procedimiento ACPM (Word)
                </button>
                <button type="button" class="btn btn-outline-primary mx-1" @click="descargarFormato('matriz')">
                  <i class="bx bx-download"></i> Matriz ACPM (Excel)
                </button>
              </div>
            </div>
          </div>

          <!-- Procedimiento ACPM (online, versionable, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Procedimiento ACPM (online)</h5>
                  <p class="text-muted small mb-1">Documento estructurado versionable con firma del encargado. Cada versión queda en el historial.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newProcedure" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nuevo procedimiento
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Versión</th>
                      <th class="text-center align-middle">Fecha aprobación</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!procedures.length"><td colspan="5" class="text-center text-muted">No hay procedimientos registrados.</td></tr>
                    <tr v-for="p in procedures" :key="p.id">
                      <td class="text-center align-middle font-weight-bold">{{ p.version }}</td>
                      <td class="text-center align-middle">{{ p.approval_date ? dateConvert(p.approval_date) : '' }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(p.workflow_status)">{{ statusText(p.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                          type="button" @click="downloadProcedurePdf(p.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editProcedure(p.id)">{{ p.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneProcedure(p.id)">Nueva versión (clonar)</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteProcedure(p.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Matriz ACPM (online, versionable + dashboard, firmable) -->
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-0">Matriz ACPM (online)</h5>
                  <p class="text-muted small mb-1">Seguimiento y control de desviaciones, versionable con dashboard y firma del encargado.</p>
                </div>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newMatrix" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus"></i> Nueva matriz
                </button>
              </div>
              <div class="table-responsive mt-1">
                <table class="table table-sm border-bottom table-striped">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Versión</th>
                      <th class="text-center align-middle">Fecha</th>
                      <th class="text-center align-middle">Acciones</th>
                      <th class="text-center align-middle">Estado</th>
                      <th class="text-center align-middle">PDF</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!matrices.length"><td colspan="6" class="text-center text-muted">No hay matrices registradas.</td></tr>
                    <tr v-for="m in matrices" :key="m.id">
                      <td class="text-center align-middle font-weight-bold">{{ m.version }}</td>
                      <td class="text-center align-middle">{{ m.fecha ? dateConvert(m.fecha) : '' }}</td>
                      <td class="text-center align-middle">{{ m.rows_count }}</td>
                      <td class="text-center align-middle"><span class="badge" :class="statusBadgeClass(m.workflow_status)">{{ statusText(m.workflow_status) }}</span></td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                          type="button" @click="downloadMatrixPdf(m.id)" title="Descargar PDF">
                          <i class="mdi mdi-file-pdf-box" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!getRole('Editar')" @click="editMatrix(m.id)">{{ m.workflow_status === 'signed' ? 'Ver' : 'Editar' }}</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneMatrix(m.id)">Nueva versión (clonar)</b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteMatrix(m.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Subida libre de documentos ACPM diligenciados -->
          <div class="card">
            <div class="card-body">
              <h5 class="mb-1">Documentos diligenciados</h5>
              <p class="text-muted small">
                Sube el procedimiento o la matriz ACPM ya diligenciados, o cualquier evidencia relacionada.
              </p>

              <div class="form-row align-items-end">
                <b-form-group class="col-md-4 px-2" label="Nombre del documento">
                  <b-form-input v-model="acpmDoc.name" :disabled="!getRole('Crear') || !allowAccess()" size="sm"
                    placeholder="Ej: Matriz ACPM 2026" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Tipo">
                  <b-form-select v-model="acpmDoc.doc_type" :disabled="!getRole('Crear') || !allowAccess()" size="sm">
                    <b-form-select-option v-for="t in docTypes" :key="t" :value="t">{{ t }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-2" label="Fecha de subida">
                  <b-form-input v-model="acpmDoc.upload_date" :disabled="!getRole('Crear') || !allowAccess()"
                    type="date" size="sm" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Responsable">
                  <b-form-input v-model="acpmDoc.responsible" :disabled="!getRole('Crear') || !allowAccess()" size="sm"
                    placeholder="Quién lo diligenció" />
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="Observaciones">
                  <b-form-input v-model="acpmDoc.observations" :disabled="!getRole('Crear') || !allowAccess()"
                    size="sm" placeholder="Opcional" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Archivo">
                  <b-form-file ref="acpmFile" :disabled="!getRole('Crear') || !allowAccess()" browse-text="Buscar"
                    placeholder="Selecciona un archivo..." @change="onAcpmFile"
                    accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,image/*" size="sm" />
                </b-form-group>
                <div class="col-md-2 px-2 pb-2">
                  <button type="button" class="btn btn-primary btn-sm btn-block"
                    :disabled="acpmSubmitting || !getRole('Crear') || !allowAccess()" @click="saveAcpmDoc">
                    {{ acpmSubmitting ? '...' : 'Subir' }}
                  </button>
                </div>
              </div>

              <div class="table-responsive mt-2" v-if="getRole('Consultar') || !allowAccess()">
                <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Fecha de subida</th>
                      <th class="text-center align-middle">Nombre</th>
                      <th class="text-center align-middle">Tipo</th>
                      <th class="text-center align-middle">Responsable</th>
                      <th class="text-center align-middle">Observaciones</th>
                      <th class="text-center align-middle">Descargar</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-if="!acpmDocs.length">
                      <td colspan="7" class="text-center text-muted">No hay documentos cargados.</td>
                    </tr>
                    <tr v-for="doc in acpmDocs" :key="doc.id">
                      <td class="text-center align-middle">{{ dateConvert(doc.upload_date || doc.created_at) }}</td>
                      <td class="text-center align-middle">{{ doc.name }}</td>
                      <td class="text-center align-middle">{{ doc.doc_type }}</td>
                      <td class="text-center align-middle">{{ doc.responsible }}</td>
                      <td class="text-center align-middle">{{ doc.observations }}</td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess()"
                          style="background-color: transparent !important; border: none;" type="button"
                          @click="gotoDigitalOcean(doc.file)"><i class="mdi mdi-cloud-download"></i></button>
                      </td>
                      <td class="text-center align-middle">
                        <button :disabled="!getRole('Eliminar') || !allowAccess()"
                          class="btn btn-outline-danger btn-sm py-0" type="button" @click="deleteAcpmDoc(doc.id)"><i
                            class="mdi mdi-trash-can"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center pt-4">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
